// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"86834bff","705":"cad15934","787":"fb771931","807":"06c73919","982":"797635ca"}[chunkId] + ".chunk.js";
};